import { Registry, EventRegistryData } from '../../eventSite/eventRegistry';
import { Photo } from '../../eventSite/eventSource';

const EVENT_UUID_QUERY = (website: string) => `
  query {
    eventByName(name: "${website}"){
      id
    }
  }
`;

const REGISTRY_PAGE_QUERY = (eventUUID: string) => `
  query {
    getRegistryEventData(eventId: "${eventUUID}"){
      shouldDisplayItems
    }
  }
`;

const REGISTRY_QUERY = (website: string) => `
  query {
    eventByName(name: "${website}"){
      id
      pages(admin:true){
        id
        type
        pageTitle
        pageSubTitleV0918
        pageSlug
        primaryPhotoHorizontal: photo {
          assetId
          height
          key: id
          mimeType
          fileSize
          width
        }
        mobilePhoto {
          assetId
          height
          id
          mimeType
          fileSize
          width
        }
      }
      info(admin:true){
        registry{
          id
          urlV0204
          nameV0204
          imageUrlV0204
        }
      }
    }
  }
`;

const REGISTRY_CHECK_ITEMS_QUERY = (website: string) => `
  query {
    eventByName(name: "${website}"){
      info(admin:true){
        registry{
          hasItems
        }
      }
    }
  }
`
type GatewayRegistry = {
  id: string,
  urlV0204: string,
  nameV0204: string,
  imageUrlV0204: string
}

type RegistryPage = {
  id: string,
  type: string,
  pageTitle: string,
  pageSubTitleV0918: string,
  pageSlug: string,
  primaryPhotoHorizontal: Photo,
}

const reformatRegistry = (registryEntry: GatewayRegistry): Registry => {
  return {
    key: registryEntry.id,
    url: registryEntry.urlV0204,
    name: registryEntry.nameV0204,
    logoUrl: registryEntry.imageUrlV0204
  }
}

const unpackRegistryPage = (data): RegistryPage => {
  return data.eventByName.pages
    .filter(m => m.type === "registry")[0];
}

const unpackRegistries = (data): GatewayRegistry[] => {
  /* make sure to hide the standalone registry, brannan does not display items so we do not need
  to do anything with the custom items */
  return data.eventByName.info.registry.filter(registry => registry.id !== data.eventByName.id);
}

const collectWebsite = async (dataSource): Promise<string> => {
  return new Promise((res, rej) => {
    dataSource.observeOnceWebsite({ onValue: (website) => res(website) })
  }) as Promise<string>;
}

export const collectData = async (dataSource, gateway: any): Promise<EventRegistryData> => {
  const website = await collectWebsite(dataSource);
  const data = await gateway.queryGraphQLWithErrors(REGISTRY_QUERY(website));
  const registries = unpackRegistries(data)
    .map(reformatRegistry);
  const page = unpackRegistryPage(data);
  if(page.primaryPhotoHorizontal && page.primaryPhotoHorizontal.assetId) {
    page.primaryPhotoHorizontal.assetId = decodeURIComponent( page.primaryPhotoHorizontal.assetId );
  }
  return {
    stores: registries,
    note: page.pageSubTitleV0918,
    primaryPhotoHorizontal: page.primaryPhotoHorizontal,
  }
}

export const shouldDisplayRegistryPage = async (dataSource, gateway: any): Promise<boolean> => {
  const website = await collectWebsite(dataSource);
  const uuidData = await gateway.queryGraphQLWithErrors(EVENT_UUID_QUERY(website));
  const uuid = uuidData.eventByName.id;
  const data = await gateway.queryGraphQLWithErrors(REGISTRY_PAGE_QUERY(uuid));
  return data.getRegistryEventData.shouldDisplayItems;
}

export const registryHasItems = async (dataSource, gateway: any): Promise<boolean> => {
  const website = await collectWebsite(dataSource);
  const data = await gateway.queryGraphQLWithErrors(REGISTRY_CHECK_ITEMS_QUERY(website));
  for (let registry of data.eventByName.info.registry) {
    if(registry.hasItems === true) { return true; }
  }
  return false;
}

